import { clsx } from "clsx";
import { InputCheckboxWithoutControl } from "@/components/common/inputs";
import { InputDropdownOptionProps } from "../index";
import { InputDropdownOptionRadio } from "../OptionRadio";

type Props = {
  field: string;
  option: InputDropdownOptionProps;
  onClick: (item: string) => void;
  isSelected?: boolean;
  variant?: "radio" | "check";
  disabled?: boolean;
};

export const InputDropdownItem = ({ field, option, isSelected, variant = "check", onClick, disabled }: Props) => {
  const handleClickItem = () => {
    if (!disabled) {
      onClick(option.value);
    }
  };

  return (
    <div
      className={clsx("w-full transition-all", {
        "opacity-40 grayscale pointer-events-none cursor-not-allowed": disabled,
      })}
    >
      {variant === "radio" ? (
        <InputDropdownOptionRadio
          id={`${field}-${option.value}`}
          selected={isSelected}
          onChange={handleClickItem}
          label={option.label}
        />
      ) : (
        <InputCheckboxWithoutControl
          id={`${field}-${option.value}`}
          selected={isSelected}
          onChange={handleClickItem}
          label={option.label}
          className="w-full p-2 [&_label]:pl-0 [&_label]:pr-6 [&_label::before]:!left-auto [&_label::before]:right-0"
        />
      )}
    </div>
  );
};
